import i18next from "i18next";
import {
  participantsPrivacy,
  participantsTerms,
  userPrivacy,
  userTerms,
  support,
  participantsPrivacyLanguages,
  participantsTermsLanguages,
  userPrivacyLanguages,
  userTermsLanguages,
  supportLanguages,
  translations,
} from "../api/endpoint";
export const EDIT_PARAMS = "EDIT_PARAMS";

export const GET_PARTICIPANT_PRIVACY_REQUEST =
  "GET_PARTICIPANT_PRIVACY_REQUEST";
export const GET_PARTICIPANT_PRIVACY_SUCCESS =
  "GET_PARTICIPANT_PRIVACY_SUCCESS";
export const GET_PARTICIPANT_PRIVACY_ERROR = "GET_PARTICIPANT_PRIVACY_ERROR";

export const GET_PARTICIPANT_TERM_REQUEST = "GET_PARTICIPANT_TERM_REQUEST";
export const GET_PARTICIPANT_TERM_SUCCESS = "GET_PARTICIPANT_TERM_SUCCESS";
export const GET_PARTICIPANT_TERM_ERROR = "GET_PARTICIPANT_TERM_ERROR";

export const GET_USER_PRIVACY_REQUEST = "GET_USER_PRIVACY_REQUEST";
export const GET_USER_PRIVACY_SUCCESS = "GET_USER_PRIVACY_SUCCESS";
export const GET_USER_PRIVACY_ERROR = "GET_USER_PRIVACY_ERROR";

export const GET_USER_TERM_REQUEST = "GET_USER_TERM_REQUEST";
export const GET_USER_TERM_SUCCESS = "GET_USER_TERM_SUCCESS";
export const GET_USER_TERM_ERROR = "GET_USER_TERM_ERROR";

export const GET_SUPPORT_REQUEST = "GET_SUPPORT_REQUEST";
export const GET_SUPPORT_SUCCESS = "GET_SUPPORT_SUCCESS";
export const GET_SUPPORT_ERROR = "GET_SUPPORT_ERROR";

export const GET_LANGUAGES_REQUEST = "GET_LANGUAGES_REQUEST";
export const GET_LANGUAGES_SUCCESS = "GET_LANGUAGES_SUCCESS";
export const GET_LANGUAGES_ERROR = "GET_LANGUAGES_ERROR";

export const GET_TRANSLATIONS_ERROR = "GET_TRANSLATIONS_ERROR";
export const GET_TRANSLATIONS_SUCCESS = "GET_TRANSLATIONS_SUCCESS";
export const GET_TRANSLATIONS_REQUEST = "GET_TRANSLATIONS_REQUEST";

export function setParams({ user_type, version, language }) {
  return (dispatch) => {
    dispatch({
      type: EDIT_PARAMS,
      payload: { user_type, version, language },
    });
  };
}

export function getParticipantsPrivacy({ version, language }) {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_PARTICIPANT_PRIVACY_REQUEST,
      });

      const { data } = await participantsPrivacy(version, language);
      dispatch({
        type: GET_PARTICIPANT_PRIVACY_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      dispatch({
        type: GET_PARTICIPANT_PRIVACY_ERROR,
      });
    }
  };
}

export function getUserPrivacy({ version, language }) {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_USER_PRIVACY_ERROR,
      });
      const { data } = await userPrivacy(version, language);

      dispatch({
        type: GET_USER_PRIVACY_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      dispatch({
        type: GET_USER_PRIVACY_ERROR,
      });
    }
  };
}

export function getParticipantsTerms({ version, language }) {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_PARTICIPANT_TERM_REQUEST,
      });

      const { data } = await participantsTerms(version, language);
      dispatch({
        type: GET_PARTICIPANT_TERM_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      dispatch({
        type: GET_PARTICIPANT_TERM_ERROR,
      });
    }
  };
}

export function getUserTerms({ version, language }) {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_USER_TERM_REQUEST,
      });
      const { data } = await userTerms(version, language);
      dispatch({
        type: GET_USER_TERM_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      dispatch({
        type: GET_USER_TERM_ERROR,
      });
    }
  };
}

export function getSupport({ language }) {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_SUPPORT_REQUEST,
      });

      const { data } = await support(language);

      dispatch({
        type: GET_SUPPORT_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      dispatch({
        type: GET_SUPPORT_ERROR,
      });
    }
  };
}

export function getParticipantsPrivacyLanguages({ version }) {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_LANGUAGES_REQUEST,
      });
      const { data } = await participantsPrivacyLanguages(version);
      dispatch({
        type: GET_LANGUAGES_SUCCESS,
        payload: data.languages,
      });

      return data;
    } catch (error) {
      dispatch({
        type: GET_LANGUAGES_ERROR,
      });
    }
  };
}

export function getParticipantsTermsLanguages({ version }) {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_LANGUAGES_REQUEST,
      });
      const { data } = await participantsTermsLanguages(version);
      dispatch({
        type: GET_LANGUAGES_SUCCESS,
        payload: data.languages,
      });

      return data;
    } catch (error) {
      dispatch({
        type: GET_LANGUAGES_ERROR,
      });
    }
  };
}
export function getUserPrivacyLanguages({ version }) {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_LANGUAGES_REQUEST,
      });
      const { data } = await userPrivacyLanguages(version);
      dispatch({
        type: GET_LANGUAGES_SUCCESS,
        payload: data.languages,
      });

      return data;
    } catch (error) {
      dispatch({
        type: GET_LANGUAGES_ERROR,
      });
    }
  };
}

export function getUserTermsLanguages({ version }) {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_LANGUAGES_REQUEST,
      });
      const { data } = await userTermsLanguages(version);
      dispatch({
        type: GET_LANGUAGES_SUCCESS,
        payload: data.languages,
      });

      return data;
    } catch (error) {
      dispatch({
        type: GET_LANGUAGES_ERROR,
      });
    }
  };
}

export function getSupportLanguages() {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_LANGUAGES_REQUEST,
      });
      const { data } = await supportLanguages();
      dispatch({
        type: GET_LANGUAGES_SUCCESS,
        payload: data.languages,
      });

      return data;
    } catch (error) {
      dispatch({
        type: GET_LANGUAGES_ERROR,
      });
    }
  };
}

export function getTranslations() {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_TRANSLATIONS_REQUEST,
      });
      const { data } = await translations();

      dispatch({
        type: GET_TRANSLATIONS_SUCCESS,
        payload: data.languages,
      });
      const languages = data.languages;

      for (const language of languages) {
        i18next.addResources(
          language.code,
          "translation",
          language.translation
        );
      }
      return data.languages;
    } catch (error) {
      dispatch({
        type: GET_TRANSLATIONS_ERROR,
      });
    }
  };
}
